import React, { useCallback } from 'react'

import { useTab } from '../../tabs/hooks'

import { BASE_URL, ICONS } from '../../constants'

import styles from './MapDataToggle.module.css'

const MapDataToggle = ({ mapPath, listPath }) => {
  const [_, selectMap] = useTab(mapPath)
  const [isListSelected, selectList] = useTab(listPath)

  const selectFunc = useCallback(() => {
    return isListSelected ? selectMap : selectList
  }, [isListSelected, selectMap, selectList])

  const iconFile = isListSelected ? 'MapIcon.png' : 'ListIcon.png'

  return (
    <img
      className={styles.toggle}
      alt="Map/Data Toggle"
      src={BASE_URL + ICONS.DIR + iconFile}
      onClick={selectFunc()}
    />
  )
}

export default MapDataToggle
